import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-in-maintenance',
  templateUrl: './in-maintenance.component.html',
  styleUrls: ['./in-maintenance.component.scss']
})
export class InMaintenanceComponent{

  constructor(public router:Router) { }

  public goHome(): void {
    this.router.navigate(['/']);
  }
}
